export class ReturnResult<T>{
    message: string;
    result: T;
    extend?: any;
}
export class ReturnSearchResult<T> extends  ReturnResult<T>{
    total: number;
}

export class AccountOpportunityResult<T> extends  ReturnResult<T>{
    referenceObject : any;
 }